import type { ReactNode } from 'react';

export type ChipTone = 'neutral' | 'accent' | 'warn' | 'danger' | 'ok' | 'timewarp' | 'ai';

const TONE: Record<ChipTone, string> = {
  neutral: 'border-border-2 bg-surface-2 text-fg-2',
  accent: 'border-accent/35 bg-accent/10 text-accent',
  warn: 'border-warn/40 bg-warn/12 text-warn',
  danger: 'border-danger/40 bg-danger/12 text-danger',
  ok: 'border-border-2 bg-surface-2 text-fg-2',
  timewarp: 'border-timewarp/45 bg-timewarp-soft text-timewarp-ink',
  ai: 'border-accent-ai/40 bg-accent-ai-soft text-accent-ai',
};

/** 11px 的狀態標記。資料介面裡每一個 chip 都必須說明一件事實，不做裝飾。 */
export function Chip({
  tone = 'neutral',
  children,
  title,
  mono = false,
}: {
  tone?: ChipTone | undefined;
  children: ReactNode;
  title?: string | undefined;
  mono?: boolean | undefined;
}) {
  return (
    <span
      title={title}
      className={[
        'inline-flex items-center gap-1 rounded-pill border px-1.5 py-px text-11 whitespace-nowrap',
        mono ? 'mono' : '',
        TONE[tone],
      ].join(' ')}
    >
      {children}
    </span>
  );
}

/** 狀態圓點。/status 的資料集健康與 explorer 的稽核判定共用同一個形狀。 */
export function Dot({ className = '' }: { className?: string }) {
  return <span className={`inline-block size-1.5 shrink-0 rounded-pill ${className}`} />;
}
